export default __webpack_public_path__ + "static/media/page-not-found-loop.e6c015cc.gif";